import React from 'react'

export function Portfolio() {
  return (
    <React.Fragment>
      Coming soon
    </React.Fragment>
  )
}
